module.exports = __webpack_public_path__ + "img/prolungato_laterale_dx.3c4b8a0e.png";